/* eslint-disable no-nested-ternary */
import React from 'react';
import s from './StaticContent.scss';

class StaticContent extends React.Component {
  render() {
    return (
      <div className={s.aboutPage}>
        <div className={s.aboutWrap}>
          <div className={s.aboutContent}>
            <div className={s.topHead}>
              <figure className={s.toiLogo}>
                <img
                  src="https://static.toiimg.com/photo/108295006.cms"
                  alt=""
                />
              </figure>
              <figure className={s.finacialLogo}>
                <img
                  src="https://static.toiimg.com/photo/108295010.cms"
                  alt=""
                />
              </figure>
            </div>
            <div className={s.webContent}>
              <h1>
                India’s Journey to
                <span> Financial Independence </span>
                Starts Today!
              </h1>
              <div className={s.litracyLogo}>
                <figure>
                  <img
                    src="https://static.toiimg.com/photo/108295009.cms"
                    alt=""
                  />
                </figure>
              </div>
              <div className={s.description}>
                <p>
                  The revolution to a financial literate India is going to bring
                  another shade of independence to the country. Empowering and
                  transforming the life of millions with knowledge, skills,
                  technology and resources from financial luminaries. The
                  <strong> Times of India </strong> and
                  <strong> StockGro </strong> have joined hands for this epic in
                  initiative, which will bridge the great divide in our society
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default StaticContent;
